import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./app/store/store";
import "./services/apiBootstrap";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Auth0Provider
    domain="dev-tthzw3uiioypptkj.us.auth0.com"
    clientId="flqFB9wWez8Ld0z3i40ZYJhmO9LRvEHU"
    redirectUri={`${window.location.origin}/authentication/redireccion`}
  >
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </Auth0Provider>
);
